import { AddressModel } from "@verivest/shared-components/src/api/models";
import { validateAllAttributesExistInData } from "./validateAllAttributesExistInData";

export const validateAddressReqAttr = (
  address: AddressModel | null | undefined,
) => {
  if (!address) {
    return false;
  }

  const addressReqAttr: Array<keyof AddressModel> = [
    "address1",
    "city",
    "region",
    "postalCode",
    "country",
  ];

  return validateAllAttributesExistInData(addressReqAttr, address);
};
